import React from 'react'
import PropTypes from 'prop-types'
// import classNames from 'classnames'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { withStyles } from '@material-ui/core/styles'
import { Translation } from 'react-i18next'
import Checkbox from '@material-ui/core/Checkbox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import moment from 'moment'

const styles = (theme) => ({
  tablecell1: {
    fontSize: '12px',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    verticalAlign: 'top'
  }
})

const WorkshiftJournalRow = ({
  key,
  classes,
  invoice_id,
  journal_id,
  task_description,
  totalJournalAmount,
  dateTimeRows,
  attachWorkshiftJournalId, // this action is called when journal checkbox is triggered
  attachedWorkShiftJournalIds, // this is state to save selected journals id
  isEditInvoice,
  edit_invoice_id
}) => {
  // const [detach, setDetach] = React.useState(false)
  // console.log('huong detach', detach)
  const selectedIds = attachedWorkShiftJournalIds
  const handleOnChange = () => {
    attachWorkshiftJournalId(journal_id)
    // if (isEditInvoice) {
    //   if (!e.target.checked) {
    //     setDetach(true)
    //   }
    // }
  }
  return (
    <Translation>
      {() => {
        return (
          <TableRow key={key}>
            <TableCell
              component="th"
              scope="row"
              className={classes.tablecell1}
              padding="checkbox"
            >
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
                checkedIcon={
                  <CheckBoxIcon fontSize="large" style={{ fill: '#F67131' }} />
                }
                onChange={handleOnChange}
                checked={selectedIds.includes(journal_id)}
                disabled={
                  invoice_id !== edit_invoice_id && invoice_id !== null
                    ? true
                    : false
                }
              />
            </TableCell>
            <TableCell
              component="th"
              scope="row"
              className={classes.tablecell1}
            >
              {/* {detach || */}
              {(isEditInvoice && attachedWorkShiftJournalIds.length === 0) ||
              !attachedWorkShiftJournalIds.includes(journal_id)
                ? null
                : edit_invoice_id}
            </TableCell>
            <TableCell
              component="th"
              scope="row"
              className={classes.tablecell1}
            >
              {journal_id}
            </TableCell>
            <TableCell
              component="th"
              scope="row"
              className={classes.tablecell1}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: task_description
                }}
              ></div>
            </TableCell>
            <TableCell
              component="th"
              scope="row"
              className={classes.tablecell1}
            >
              {dateTimeRows.map((el, index) => (
                <p style={{ margin: 0 }} key={index}>
                  {moment(el.date).format('DD.MM.YYYY')}
                </p>
              ))}
            </TableCell>
            {/* <TableCell
              component="th"
              scope="row"
              className={classes.tablecell1}
            >
              {dateTimeRows.map((el) => (
                <p style={{ margin: 0 }}>
                  {new Intl.NumberFormat('fi-FI', {
                    style: 'currency',
                    currency: 'EUR'
                  }).format(el.amount)}
                </p>
              ))}
            </TableCell> */}
            <TableCell
              component="th"
              scope="row"
              className={classes.tablecell1}
            >
              {totalJournalAmount}
            </TableCell>
            {/* <TableCell
              component="th"
              scope="row"
              className={classes.tablecell1}
            ></TableCell> */}
          </TableRow>
        )
      }}
    </Translation>
  )
}

WorkshiftJournalRow.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(WorkshiftJournalRow)
